import { ReactElement } from 'react';
import Spinner from 'react-bootstrap/Spinner';

const LoadingComponent = (): ReactElement => {
  return <Spinner className="loader" animation="border" role="status" />;
};

export default LoadingComponent;
